import signSuccessMq from './img/sign-success-mq.png';
import mqLogo from './img/logo/meiqia/favicon.ico-BESPOKE';
import mqSettingNoMatch from './img/meiqia-setting-no-match.png';
import mqProdoct from './temp/product-card-import-template-mq.xlsx';
import mqService from './temp/meiqia-service.html';
import mqIndentity from './img/indentity.png';
import mqBcpEmpty from './img/emptypag_baidu.png';
import mqEWM from './img/meiqia-ewm.jpg';
import { replaceTxtFn } from '@/utils/bespoke-config/config';

export default {
  meiqia: {
    企业标识: 'meiqia',
    企业名称: '美洽',
    工作台地址: 'https://app.meiqia.com',
    企业付款连接: '/setting/payment/',
    企业聊天链接: replaceTxtFn(
      'processor_enterprise_chat_link',
      'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b'
    ),
    '企业聊天链接-试用': 'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b',
    企业体验版聊天链接:
      'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b&subSource=sub_source_57',
    logo链接: mqLogo,
    支持邮箱: 'support@meiqia.com',
    二维码: mqEWM,
    'JS SDK添加顾客自定义事件信息URL': 'https://meiqia.com/help/development/lqqomu#yrVxZ',
    服务开发文档: 'https://meiqia.com/help/development/wtpzpf',
    注册成功图片: signSuccessMq,
    服务企业ID: 'b269235deb4454abab2f0e543d39725b',
    'IOS SDK下载': 'https://github.com/Meiqia/MeiqiaSDK-iOS/releases',
    'IOS SDK开发文档': 'https://meiqia.com/help/development/ve0wil',
    'IOS SDK演示demo': 'https://github.com/Meiqia/MeiqiaSDK-iOS/releases',
    'IOS SDKGithub': 'https://github.com/Meiqia/MeiqiaSDK-iOS',
    'Android SDK下载': 'https://github.com/Meiqia/MeiqiaSDK-Android/releases',
    'Android SDK开发文档': 'https://meiqia.com/help/development/dlu4mi',
    'Android SDK演示demo': 'https://github.com/Meiqia/MeiqiaSDK-Android/releases',
    'Android SDKGithub': 'https://github.com/Meiqia/MeiqiaSDK-Android',
    消息推送href: 'https://meiqia.com/help/development/ve0wil#JXlsh',
    'iOS SDK 问题href': 'https://meiqia.com/help/development/ve0wil#vblXk',
    '如何得到客服 ID 或客服分组 IDhref': 'https://meiqia.com/help/development/ve0wil#pUeyh',

    聊天链接接口说明URL: 'https://meiqia.com/help/development/lqqomu#2q6RG',
    '聊天链接-自定义域名URL': 'https://meiqia.com/help/faqs/tb9fwv',
    申请开通聊天连接: 'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b',
    默认链接href: 'https://{{defaultDomain}}/widget/standalone.html?eid={{entId}}',

    'js-sdk': 'https://meiqia.com/help/development/lqqomu',
    jsSrc: 'https://static.meiqia.com/widget/loader.js',
    用户变量: '_MEIQIA',

    logoUrl: replaceTxtFn('processor_logo_url', 'ecoboost-iconfontlogo_meiqia'),
    条款链接: replaceTxtFn('agree_auth_agreement', 'https://meiqia.com/agreement'),
    '条款链接-模态框': 'https://meiqia.com/agreement/ageement-only',
    商品模板: mqProdoct,

    即将过期提示:
      '你的账号{{版本}}将于 {{过期时间}} 过期，届时会将自动转为体验版，相应功能将被冻结，续费后立即恢复，如需继续使用点此',
    已过期提示:
      '你的账号{{版本}}已于 {{过期时间}} 过期，已自动转为体验版，相应功能已冻结，续费后立即恢复，如需继续使用点此',
    购买按钮: '立即续费',

    顾客查询条件缺省: 'ecoboost-iconfontemptypag_general_05',
    智能学习缺省: 'ecoboost-iconfontemptypag_robot_01',
    默认缺省: 'ecoboost-iconfontemptypag_tickets_02',
    质检缺省: 'ecoboost-iconfontemptypag_general_06',
    机器人缺省: 'ecoboost-iconfontemptypag_general_07',
    顾客名片缺省: 'ecoboost-iconfontemptypag_chat_04',
    快捷回复缺省: 'ecoboost-iconfontemptypag_general_02',
    留言分类缺省: 'ecoboost-iconfontemptypag_general_04',
    iframe配置缺省: 'ecoboost-iconfontemptypag_general_03',
    通话配置缺省: 'ecoboost-iconfontemptypag_tickets_022',
    设置页缺省: mqSettingNoMatch,
    对话列表缺省: 'ecoboost-iconfontemptypag_chat_01',
    暂无对话缺省: 'ecoboost-iconfontemptypag_chat_02',
    对话标签缺省: 'ecoboost-iconfontemptypag_chat_05',
    对话转接缺省: 'ecoboost-iconfontemptypag_chat_06',
    留言列表缺省: 'ecoboost-iconfontemptypag_tickets_01',
    暂无留言缺省: 'ecoboost-iconfontemptypag_tickets_02',
    暂无通话缺省: 'ecoboost-iconfontemptypag_call_02',

    如何配置软电话链接: 'https://baidu.com',
    选择质检方案缺省: 'ecoboost-iconfontemptypag_general_08',
    未订购功能缺省: 'ecoboost-iconfontemptypag_general_081',
    服务合同: mqService,
    服务合同字段: '服务合同',
    未认证身份缺省: mqIndentity,
    utp检测: replaceTxtFn(
      'processor_utp_check',
      'https://api.meiqia.com,https://app.meiqia.com,https://static.meiqia.com,https://eco-push-api-agent.meiqia.com,https://camorope-client-a.meiqia.com'
    ),
    微信广告APPID: '1111463395',
    隐私政策Url: replaceTxtFn('agree_auth_privacy_clause', 'https://meiqia.com/privacy-clause'),
    帮助中心地址: replaceTxtFn('processor_help_center_url', 'https://meiqia.com/help'),

    无权限: 'ecoboost-iconfontemptypag_chat_031',
    引导配置: 'ecoboost-iconfontemptypag_tickets_021',
    在线客服咨询聊天链接: replaceTxtFn(
      'processor_online_chat_link',
      'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b&subSource=sub_source_22'
    ),
    语音机器人咨询聊天链接:
      'https://chat.meiqiayun.com/widget/standalone.html?eid=b269235deb4454abab2f0e543d39725b&subSource=sub_source_50',
    了解更多链接: replaceTxtFn('processor_known_more_link', 'https://meiqia.com/pricing'),
    百度bcp缺省: mqBcpEmpty,
    ISO下载: 'https://apps.apple.com/cn/app/mei-qia-yi-dong-zai-xian-ke-fu/id1050591118',
    安卓下载: 'https://meiqia.com/downloads/android',
    了解询前表单: 'https://meiqia.com/help/product-manual/cg20n7',
    link_了解对话分配规则: 'https://meiqia.com/help/product-manual/wl65v1',
    link_如何使用自动规则: replaceTxtFn('processor_auto_rule_url', 'https://meiqia.com/help/article/auto-rules'),
    webhooks: replaceTxtFn('processor_webhooks_url', 'https://meiqia.com/help/article/webhooks'),
    如何使用广告平台: 'https://meiqia.com/help/article/access-channel',
    apis: replaceTxtFn('processor_apis_link', 'https://meiqia.com/help/article/apiv2-0')
  }
};
